import { Button, ButtonProps } from "@mui/material";
import { useTranslation } from "react-i18next";

export const BackButton = <T extends React.ElementType>(
  props: ButtonProps<T, { component?: T }>
) => {
  const { t } = useTranslation();

  return (
    <Button {...props} color="inherit">
      {t("back")}
    </Button>
  );
};
